import { brand } from "@/brandVariables/getBandVariables";
import { LeaderboardIsEmpty } from "../components/LeaderboardStates/LeaderboardIsEmpty";
import { LeaderboardHasThreeScores } from "../components/LeaderboardStates/LeaderboardHasThreeScores";
import { LeaderboardHasOneScore } from "../components/LeaderboardStates/LeaderboardHasOneScore";
import { LeaderboardHasTwoScores } from "../components/LeaderboardStates/LeaderboardHastwoScores";
import { Racing_leaderboard } from "../components/Racing_leaderboard";
import { ClientProps } from "@/hooks/useClientData";
import { LogitechCustomLeaderboardIsEmpty } from "../components/customClientStates/logitech.empty";

export const leaderboardRenderer = ({
  leaderboardLength,
  clientData,
}: {
  clientData: ClientProps;
  leaderboardLength: number;
}) => {
  const clientsToRenderAll = [
    "LOGITECH",
    "LEGO-gdjkr",
    "ELGIGANTEN",
    "elgiganten-9u2oj",
    "logitechg-7vvzz",
  ];

  const returnAll = clientsToRenderAll.includes(brand.client);

  if (
    brand.client === "logitechg-7vvzz" &&
    (!leaderboardLength || leaderboardLength === 0)
  ) {
    return <LogitechCustomLeaderboardIsEmpty clientData={clientData} />;
  }

  if (!leaderboardLength || leaderboardLength === 0) {
    return <LeaderboardIsEmpty clientData={clientData} />;
  }

  if (returnAll && leaderboardLength <= 3) {
    return <LeaderboardHasThreeScores clientData={clientData} />;
  }

  if (leaderboardLength === 1) {
    // Return leaderboard state for 1 user
    return <LeaderboardHasOneScore clientData={clientData} />;
  }

  if (leaderboardLength === 2) {
    // Return leaderboard state for 2 users
    return <LeaderboardHasTwoScores clientData={clientData} />;
  }

  if (leaderboardLength === 3) {
    // Return leaderboard state for 3 users
    return <LeaderboardHasThreeScores clientData={clientData} />;
  }

  // Return leaderboard state for all users
  return <Racing_leaderboard clientData={clientData} />;
};
